import React from 'react';

export const Glass = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.50001 5.5C9.50001 7.70914 7.70915 9.5 5.50001 9.5C3.29087 9.5 1.50001 7.70914 1.50001 5.5C1.50001 3.29086 3.29087 1.5 5.50001 1.5C7.70915 1.5 9.50001 3.29086 9.50001 5.5ZM8.48569 10.1198C7.62584 10.6767 6.60068 11 5.50001 11C2.46245 11 1.14441e-05 8.53757 1.14441e-05 5.5C1.14441e-05 2.46243 2.46245 0 5.50001 0C8.53758 0 11 2.46243 11 5.5C11 6.89482 10.4808 8.16838 9.62509 9.13792L11.4569 10.9698C11.7498 11.2626 11.7498 11.7375 11.4569 12.0304C11.164 12.3233 10.6891 12.3233 10.3963 12.0304L8.48569 10.1198Z"
        fill="var(--color-main)"
      />
    </svg>
  );
};
